(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["noahq-size-table"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nq-size-table')) {
    customElements.define('nq-size-table', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => {
          const scroll = this.querySelector('.nq-size-table-scroll');
          const table = scroll?.querySelector('table');
          const hint = this.querySelector('.nq-size-table-hint');
          if (!scroll || !table || !hint) return;

          const sync = () => {
            const overflowing = scroll.clientWidth > 0 && scroll.scrollWidth > scroll.clientWidth;
            hint.hidden = !overflowing;
            if (overflowing) {
              scroll.setAttribute('tabindex', '0');
            } else {
              scroll.removeAttribute('tabindex');
            }
          };

          this.observer = new ResizeObserver(sync);
          this.observer.observe(scroll);
          this.observer.observe(table);
          sync();
        });
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.observer?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
